<script lang="ts">
  import { parseContentVariables } from '$lib/helpers/content-variables-helper';

  export let locale;
</script>

<li class="FooterLinkSubcomponent" data-entry-id={$$props.id}>
  <a href={parseContentVariables($$props.pagePath, $$props.url, locale)}>{$$props.title}</a>
</li>

<style lang="scss">
  @layer standard-components {
    a {
      color: white;
      font-weight: var(--font-weight-medium);
      text-decoration: none;

      &:hover {
        color: var(--color-white);
      }
    }

    li {
      padding-left: 0;
    }
  }
</style>
